export const GET_PAY_PAL_FEES_START = 'GET_PAY_PAL_FEES_START';
export const GET_PAY_PAL_FEES_SUCCESS = 'GET_PAY_PAL_FEES_SUCCESS';
export const GET_PAY_PAL_FEES_ERROR = 'GET_PAY_PAL_FEES_ERROR';
export const GET_PAY_PAL_FEES_END = 'GET_PAY_PAL_FEES_END';
export const CLEAR_PAY_PAL_FEES_STORE = 'CLEAR_PAY_PAL_FEES_STORE';
